import { render, staticRenderFns } from "./payali.vue?vue&type=template&id=d815b4d8&scoped=true&"
import script from "./payali.vue?vue&type=script&lang=js&"
export * from "./payali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d815b4d8",
  null
  
)

export default component.exports